import { UsersThreeIcon } from '@phosphor-icons/react';

import { cn } from '@/lib/utils';

export interface SharedByChipProps {
  /** Display name of the teammate who authored this object. */
  authorName: string;
  className?: string;
}

/**
 * Shared-account object-level authorship marker — "Shared · {name}". Renders
 * only when the current viewer is a team member (not the account owner) and
 * the object was authored by a teammate other than themselves; callers are
 * responsible for that gating (see `useTeamAuthorNames`). Monochrome, no
 * border — mirrors the icon+text-detail shape of `TeamSettings`'s
 * `StatusPill` and `AttributionChip`, not a bordered pill.
 */
export function SharedByChip({ authorName, className }: SharedByChipProps) {
  return (
    <span
      className={cn(
        'inline-flex min-w-0 items-center gap-1 text-detail text-muted-foreground',
        className,
      )}
    >
      <UsersThreeIcon className="size-3 shrink-0" weight="regular" aria-hidden />
      <span className="truncate">Shared · {authorName}</span>
    </span>
  );
}
